import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CustomizeHttpUrlGenerator} from "../../../../store/core/url/customizeHttpUrlGenerator";
import {AbstractActionService} from "../../../core/service/v2/service/action/abstractAction.service";
import {SaleDeleteProductActionPayload} from "./payload/action/saleDeleteProductAction.payload";
import {PayloadWithId} from "../../../core/service/payload/payloadWithId";
import {SaleProductSummaryModel} from "../../modules/product/api/entity/saleProductSummary.model";
import {SaleProductSummaryConverter} from "../../modules/product/api/converter/saleProductSummary.converter";
import {ProductSummaryConverter} from "../../../product/api/entity/converter/productSummary.converter";
import {ProductSummaryModel} from "../../../product/api/entity/productSummary.model";

@Injectable()
export class SaleUpdateMultipleProductsActionService extends AbstractActionService<SaleUpdateMultipleProductsActionPayload, void> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('Sale', 'update-mutiple-products', customizeHttpUrlGenerator, httpClient);
    }
}

export class SaleUpdateMultipleProductsActionPayload extends PayloadWithId {
    productId: number;
    taxPercentage: number;
    unitPriceVatExcluded: number;
    unitPriceVatIncluded: number;
}